import {
  ServiceStatus,
  enumServiceSortOption,
} from '@rematter/frontend-lib-api-client';

import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableService = QueryHookResult<typeof useServicesList>[number];

export const useServicesList = createQueryHook(
  'shared.selectService',
  (params: {
    ids?: string[];
    searchTerm?: string;
    accountIds?: string[];
    accountAddressIds?: string[];
    status?: ServiceStatus[];
  }) => ({
    services: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          accountIds: params.accountIds,
          accountAddressIds: params.accountAddressIds,
          status: params.status,
        },
        sorting: [enumServiceSortOption.CreatedAtDesc],
        pagination: {
          limit: 20,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        status: true,
        accountId: true,
        accountAddressId: true,
      },
    },
  }),
  {
    select: (data) => data.services.entries ?? [],
  },
);

export const SelectServiceTouch = createEntityTouchSelect.remotelySearched(
  'SelectService',
  useServicesList,
  {
    formatLabel: (entity) => `#${entity.documentNumber}`,
    formatSubLabel: (entity) => entity.status,
  },
);
